var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"default-wrapper"},[_c('el-row',{staticClass:"sub-head",attrs:{"type":"flex"}},[_c('el-col',{staticClass:"sub-title"},[_c('h2',{domProps:{"innerHTML":_vm._s(_vm.title)}})]),_vm._t("side")],2),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }